import { gql } from '@apollo/client'

import {
  SIMPLE_ENTITY_FRAGMENT,
  USER_FRAGMENT,
} from '../../../common/graphql/fragments'

const UserDetailsFragment = gql`
  fragment UserDetailsFragment on User {
    ...UserFragment
    roles {
      ...SimpleEntityFragment
    }
    cuisineTypes {
      ...SimpleEntityFragment
    }
    languages {
      ...SimpleEntityFragment
    }

    updatedBy {
      id
      name
    }

    isActive
    lastLoginAt
    updatedAt
  }
  ${USER_FRAGMENT}
  ${SIMPLE_ENTITY_FRAGMENT}
`

export default UserDetailsFragment
